module.exports = __webpack_public_path__ + "media/images/favicons/westoverconnect-51dcc63256cc125a86060b9866e2c33deae7c2532cb178d0599e53dd33c6ff38.ico";